import useAuth from 'client/utils/auth/useAuth';
import { useIntl } from 'react-intl';
import Markdown from 'client/components/aria/MarkDown/Markdown';
import ErrorMessage from 'client/utils/routes/ErrorMessage/ErrorMessage';
import styles from './HomePage.module.scss';
import Button from 'client/components/aria/Button/Button';
import { useLocaleAutoSwitch } from 'i18n/localeUtils';
import Link from 'client/components/aria/Link/Link';
import PropTypes from 'prop-types';

const SignedOutHomePage = ({ homePageAbout }) => {
    const intl = useIntl();
    useLocaleAutoSwitch();
    const { signIn } = useAuth();

    return (
        <div className={styles.homePage} data-testid="homePageSignedOut">
            <hr className="govuk-section-break govuk-section-break--l govuk-section-break--visible"/>
            <h2 data-testid="signin.title">{intl.formatMessage({ id: 'signin.title' })}</h2>
            <p>{intl.formatMessage({ id: 'signin.description' }, {
                mailto: str => (
                    <Link
                        className="govuk-link"
                        href={'mailto:' + str}
                        data-testid="homepageSignedOut.supportEmail"
                    >
                        {str}
                    </Link>)
            })}
            </p>
            <p>{intl.formatMessage({ id: 'signin.description2' })} </p>
            <div className='gov-uk-sign-in-button'>
                <Button className="govuk-button govuk-button--start"
                    data-testid={'signInButton'}
                    onPress={signIn}
                    variant="default"
                    data-module="govuk-button"> {intl.formatMessage({ id: 'signin.button' })}
                    <svg className="govuk-button__start-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        width="17.5"
                        height="19"
                        viewBox="0 0 33 40"
                        aria-hidden="true"
                        focusable="false">
                        <path fill="currentColor" d="M0 0h13l20 20-20 20H0l20-20z"/>
                    </svg>
                </Button>
            </div>
            { homePageAbout?.markdown?.length > 0
                ? <Markdown data-testid='homePageAbout'>{homePageAbout.markdown}</Markdown>
                : <ErrorMessage code={404}/>
            }
        </div>
    );
};

SignedOutHomePage.propTypes = {
    homePageAbout: PropTypes.shape({ markdown: PropTypes.string })
};

SignedOutHomePage.defaultProps = {
    homePageAbout: undefined
};

export default SignedOutHomePage;
